// extracted by mini-css-extract-plugin
var _1 = "FYopEs5x";
var _2 = "FYopEs5x";
export { _1 as "product-region", _2 as "productRegion" }
